import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

export const GetFullVariantsQuery = gql`
  query variants($ids: [String!], $categoryId: String, $currencyId: String) {
    variants(where: { id_in: $ids, categoryId: $categoryId, currencyId: $currencyId }) {
      id
      sku
      ean
      definition
      inStock
      price
      recommendedPrice
      prices
      product {
        id
        title
        name
        technicalSpecification
        subtitle
        slug
        description
        metaTitle
        metaDescription
        display
        status
        price
        prices
        recommendedPrice
        tags
        sku
        weight
        weightForShipping
        images {
          id
          file
          priority
          createdAt
          values {
            id
          }
        }
        availability {
          id
          name
          title
          color
          watchDogAction
          allowedActions
        }
        neverApplyCustomerDiscounts
        customerGroupsOnlyDiscountIds
        manufacturer {
          id
          name
        }
        categories {
          id
          name
        }
        variants {
          id
          ean
          definition
        }
        purchaseLimitPerPurchase
      }
      attributeValues {
        id
        value
        title
        attribute {
          id
          isVisual
        }
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  ids: Array<string>;
  categoryId: string;
  currencyId?: string;
}

interface IResponse {
  data: any;
}

@observer
class VariantsQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { fullVariants }: any = this.props;
    return this.props.children({
      fullVariants
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetFullVariantsQuery, {
    name: 'fullVariants',
    options: props => ({
      // fetchPolicy: 'network-only',
      variables: {
        ...props,
      }
    })
  })
)(VariantsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/FullVariants.tsx